/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const JsonPatchOperation = zod
    .strictObject({
        op: zod
            .enum(['add', 'remove', 'replace', 'move', 'copy', 'test'])
            .describe(
                '\* `add` - add\n\* `remove` - remove\n\* `replace` - replace\n\* `move` - move\n\* `copy` - copy\n\* `test` - test',
            ),
        path: zod.string(),
        value: zod.unknown().optional(),
        from: zod.string().optional(),
    })
    .describe(
        'Serializer just there for swagger compliance: see https:\/\/jsonpatch.com\/',
    );

export type JsonPatchOperation = zod.input<typeof JsonPatchOperation>;
export type JsonPatchOperationOutput = zod.output<typeof JsonPatchOperation>;
